module.exports = "/assets/data/2c4fe70f8661171d1aff49f4f347925f-S4.data.json";